export interface FirstConsultationShareApiResource {
  shared_with_client_at: string | null;
}

export interface FirstConsultationShare {
  sharedWithClientAt: string | null;
}

export interface FirstConsultationVersionApiResource {
  version_number: number;
  recorded_at: string;
  recorded_by_name: string | null;
}

export interface FirstConsultationVersion {
  versionNumber: number;
  recordedAt: string;
  recordedByName: string | null;
}

export function mapApiResourceToFirstConsultationShare(
  resource: FirstConsultationShareApiResource
): FirstConsultationShare {
  return { sharedWithClientAt: resource.shared_with_client_at };
}

function mapFirstConsultationVersion(
  resource: FirstConsultationVersionApiResource
): FirstConsultationVersion {
  return {
    versionNumber: resource.version_number,
    recordedAt: resource.recorded_at,
    recordedByName: resource.recorded_by_name,
  };
}

export function mapApiResourceToFirstConsultationVersions(
  resources: FirstConsultationVersionApiResource[]
): FirstConsultationVersion[] {
  return resources.map(mapFirstConsultationVersion);
}
